/* app/js/src/components/broadcast/switcher-item/switcher-item.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host,
.container {
  cursor: default;
  width: 100%;
  height: 100%;
  background-color: white;
  font-family: "OpenSans-Regular", sans-serif;
  transition: opacity 0.2s ease;
  position: relative;
}
:host.dragging,
.container.dragging {
  opacity: 0.1;
}
.empty {
  align-items: center;
  height: 100%;
  font-size: xx-large;
  justify-content: center;
  min-width: 174px;
}
.empty span {
  color: #e2e8f1;
  scale: 2;
  transition: color 0.5s ease;
  transition: scale 0.5s ease;
}
.empty.drag-over span {
  color: #879baf;
  scale: 2.15;
}
.full {
  height: 100%;
}
.full .header {
  flex-grow: 1;
  border-bottom: 1px solid #8d8f93;
  color: white;
}
.full .header.layout-background {
  background-color: #8c5592;
}
.full .header.block-background {
  background-color: #cf5c81;
}
.full .header.stack-background {
  background-color: #55928e;
}
.full .header.media-background {
  background-color: #f4a93c;
}
.full .header.live-feed-background {
  background-color: #525e9a;
}
.full .header.gfx-background {
  background-color: #5b7f97;
}
.full .header .shortcut-label {
  font-weight: 400;
  color: white;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  align-items: flex-end;
  justify-content: center;
  width: 20px;
  display: flex;
  -webkit-user-select: none;
  user-select: none;
}
.full .header .divider {
  width: 1px;
  background-color: #ebf0f4;
  margin-right: 2px;
}
.full .header .label {
  flex-grow: 1;
  text-align: center;
}
.full .header .asset-name {
  padding: 3px 0 0 2px;
  flex-grow: 40;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 4vw;
}
.full .header .asset-name.dragging {
  opacity: 0.5;
  cursor: grabbing;
}
.full .header .asset-name[draggable=true] {
  cursor: grab;
  -webkit-user-select: none;
  user-select: none;
}
.full .header .headset-icon {
  flex-grow: 1;
}
.full .header .x-icon {
  flex-grow: 1;
  text-align: center;
  margin-right: 2px;
}
.full .middle {
  flex-grow: 100;
  min-height: 0;
  position: relative;
}
.full .middle .preview-asset {
  height: 100%;
  position: absolute;
  width: 100%;
}
.full .middle:hover .stats-container {
  display: block;
}
.full .middle .stats-container {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 10px;
  border-radius: 5px;
  z-index: 1;
}
.full .middle .stats-container .media-stats {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}
.full .middle .stats-container .media-stats .stat-row {
  display: flex;
  margin-bottom: 5px;
  text-align: left;
}
.full .middle .stats-container .media-stats .stat-row .stat-key {
  color: #f4a93c;
  min-width: 70px;
  font-weight: 700;
}
.full .middle .stats-container .media-stats .stat-row .stat-value {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.full .footer {
  background-color: #e1e6eb;
  color: #676a6c;
  border-top: 1px solid #8d8f93;
  text-align: center;
  align-items: center;
  height: 17px;
  flex-shrink: 0;
}
.full .footer .divider {
  width: 1px;
  background-color: #8d8f93;
  height: 100%;
}
.full .footer .preview-button {
  flex-grow: 4;
  font-weight: 600;
  font-size: 0.75rem;
  -webkit-user-select: none;
  user-select: none;
}
.full .footer .preview-button:hover {
  color: black;
}
.full .footer .program-button {
  flex-grow: 4;
  font-size: 0.8rem;
  font-weight: 600;
  -webkit-user-select: none;
  user-select: none;
}
.full .footer .program-button:hover {
  color: black;
}
.full .footer .volume-button {
  flex-grow: 1;
}
.full .footer .full-screen-button {
  flex-grow: 1;
}
.full .footer .full-screen-button:hover {
  font-weight: bold;
}
.full .footer .settings-button {
  flex-grow: 1;
}
.full .footer .settings-button:hover {
  font-weight: bold;
}
.circles {
  position: absolute;
  width: 100%;
}
.circles .circle {
  width: 2vh;
  height: 2vh;
  border: 1px solid white;
  margin-top: 0.5vh;
  margin-right: 0.5vh;
  border-radius: 1vh;
  display: inline-block;
  z-index: 1;
}
.circles .circle.red {
  background-color: #ef5d5d;
}
.circles .circle.green {
  background-color: #55928e;
}
evrideo-volume-icon,
evrideo-full-screen-icon,
evrideo-gear-icon {
  position: relative;
  top: 3px;
}
.show-list,
.show-list * {
  box-sizing: border-box;
}
.show-list {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}
.loading-text {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
  font-family: "OpenSans-Regular", sans-serif;
}
.show-list__container {
  overflow-y: auto;
  min-height: 0;
  background: var(--primary-white, #ffffff);
  padding: 1.5px 0px 1.5px 0px;
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  position: relative;
  width: 100%;
}
.show-list__item {
  border-style: solid;
  border-color: var(--light-other-divider, rgba(0, 0, 0, 0.1));
  border-width: 0px 0px 1px 0px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  height: 22px;
  position: relative;
}
.show-list__item.active {
  background: #00ca69;
}
.show-list__item.selection-range {
  background: rgba(0, 202, 105, 0.1);
}
.show-list__item.selection-end {
  background: rgba(0, 202, 105, 0.2);
}
.show-list__play-indicator-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  position: relative;
  cursor: pointer;
  pointer-events: all;
  z-index: 10;
}
.show-list__play-indicator-container:hover {
  background-color: rgba(0, 202, 105, 0.1);
  border-radius: 2px;
}
.show-list__play-indicator-container.stack-editing-disabled {
  cursor: default;
  pointer-events: none;
  opacity: 0.5;
}
.show-list__play-indicator {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  position: relative;
  overflow: visible;
  pointer-events: none;
}
.show-list__play-indicator path,
.show-list__play-indicator rect {
  pointer-events: none;
}
.selection-line {
  position: absolute;
  left: 9px;
  top: 22px;
  width: 2px;
  height: 22px;
  background-color: var(--success-main, #00ca69);
  z-index: 1;
}
.selection-end-circle {
  position: absolute;
  left: 6px;
  top: 6px;
  width: 8px;
  height: 8px;
  background-color: var(--success-main, #00ca69);
  border-radius: 50%;
  z-index: 2;
  transform-origin: center;
  transition: transform 0.3s ease-in-out;
}
.selection-end-circle.animate-circle {
  animation: circlePulse 0.3s ease-in-out;
}
@keyframes circlePulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.selection-line-short {
  position: absolute;
  left: 9px;
  top: -1px;
  width: 2px;
  height: 11px;
  background-color: var(--success-main, #00ca69);
  z-index: 1;
}
.show-list__index-container {
  padding: 0px 5px 0px 5px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  width: 30px;
  position: relative;
}
.show-list__index {
  color: var(--light-text-secondary, rgba(0, 0, 0, 0.54));
  text-align: center;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  position: relative;
  flex: 1;
}
.show-list__name-container {
  padding: 0px 5px 0px 5px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex: 1;
  position: relative;
  width: 4vw;
}
.show-list__name {
  background: var(--light-text-primary, linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)));
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  position: relative;
  flex: 1;
}
.show-list__duration-container {
  padding: 0px 5px 0px 5px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: flex-end;
  align-self: stretch;
  flex-shrink: 0;
  width: max-content;
  position: relative;
}
.show-list__duration {
  color: var(--light-text-secondary, rgba(0, 0, 0, 0.54));
  text-align: right;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  position: relative;
  flex: 1;
}
.show-list__visibility-control {
  padding: 0px 5px 0px 5px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  width: 21px;
  position: relative;
}
.show-list__context-menu-container {
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  width: 30px;
  position: relative;
}
.show-list__three-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 22px;
  cursor: pointer;
  padding-left: 5px;
  border-radius: 2px;
}
.show-list__three-dots svg {
  pointer-events: none;
}
.context-menu {
  position: fixed;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 120px;
  padding: 4px 0;
}
.context-menu__item {
  padding: 8px 12px;
  cursor: pointer;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 12px;
  color: #333;
}
.context-menu__item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.show-list__group-header {
  display: flex;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
  height: 14px;
  padding: 0 6px 0 4px;
  border-left: 3px solid var(--group-color, transparent);
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.55);
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-user-select: none;
  user-select: none;
  box-sizing: border-box;
  width: 100%;
}
.show-list__item.in-group {
  border-left: 3px solid var(--group-color, transparent);
}
.show-list__item.in-group .show-list__play-indicator-container {
  width: 19px;
}
.show-list__item.in-group.group-end {
  border-bottom: 2px solid var(--group-color, transparent);
}
:host {
  position: relative;
}
.span-controls {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 10;
  pointer-events: none;
}
:host:hover .span-controls {
  opacity: 1;
  pointer-events: auto;
}
.span-controls--right {
  top: 50%;
  right: -10px;
  transform: translateY(-50%);
  flex-direction: column;
}
.span-controls--bottom {
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  flex-direction: row;
}
.span-btn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}
.span-btn--plus {
  background-color: #55928e;
  color: white;
}
.span-btn--plus:hover {
  background-color: #3d7470;
}
.span-btn--minus {
  background-color: #8d8f93;
  color: white;
}
.span-btn--minus:hover {
  background-color: #6b6d71;
}
/*# sourceMappingURL=switcher-item.component.css.map */
